module.exports = __webpack_public_path__ + "img/blog-3.070a46a9.jpg";